import { memo, type ReactNode } from 'react';

export type AssetModalPanelsContextProviderProps = { children: ReactNode };

export {
  ASSET_MODAL_LEFT_PANEL_OPEN_TABS,
  AssetModalLeftPanelContext,
  AssetModalLeftPanelContextProvider,
  type AssetModalLeftPanelContextValue,
  type AssetModalLeftPanelOpenTab,
  isAssetModalLeftContentPanelOpen,
  isAssetModalLeftPanelTabOpen,
  type LeftContentPanel,
  type LeftContentPanelOpenPanel,
  leftContentPanels,
  useAssetModalLeftPanel,
} from '~/components/AssetModalV2/AssetModalLeftPanelContextProvider';
export {
  ASSET_MODAL_RIGHT_PANEL_OPEN_TABS,
  AssetModalRightPanelContext,
  AssetModalRightPanelContextProvider,
  type AssetModalRightPanelContextValue,
  type AssetModalRightPanelOpenTab,
  type AssetModalRightPanelsTab,
  isAssetModalRightPanelTabOpen,
  useAssetModalRightPanel,
} from '~/components/AssetModalV2/AssetModalRightPanelContextProvider';
export {
  AssetModalVersionsPanelContext,
  AssetModalVersionsPanelContextProvider,
  type AssetModalVersionsPanelContextValue,
  useAssetModalVersionsPanel,
} from '~/components/AssetModalV2/AssetModalVersionsPanelContextProvider';

import { AssetModalLeftPanelContextProvider } from '~/components/AssetModalV2/AssetModalLeftPanelContextProvider';
import { AssetModalRightPanelContextProvider } from '~/components/AssetModalV2/AssetModalRightPanelContextProvider';
import { AssetModalVersionsPanelContextProvider } from '~/components/AssetModalV2/AssetModalVersionsPanelContextProvider';

export const AssetModalPanelsContextProvider = memo(({ children }: AssetModalPanelsContextProviderProps) => (
  <AssetModalVersionsPanelContextProvider>
    <AssetModalLeftPanelContextProvider>
      <AssetModalRightPanelContextProvider>{children}</AssetModalRightPanelContextProvider>
    </AssetModalLeftPanelContextProvider>
  </AssetModalVersionsPanelContextProvider>
));

AssetModalPanelsContextProvider.displayName = 'AssetModalPanelsContextProvider';
